'use client';

import { c as _c } from "react/compiler-runtime";
import { type KeyboardEvent, useState } from 'react';
import { MarkAllAsReadButton } from '@module/mdrt-org/shared/components/header/components/notifications/mark-all-as-read-button/mark-all-as-read-button';
import { NotificationsList } from '@module/mdrt-org/shared/components/header/components/notifications/notifications-list/notifications-list';
import { useNotifications } from '@module/mdrt-org/shared/components/providers/notifications-context';
import { Card } from '@shared/ui-components/card/card';
import { GTM_ACTION_CLICK, GTM_EVENT_NAME_HEADER_CLICK, GTM_EVENT_USER_INTERACTIONS } from '@shared/utils/constants/gtm';
import { KeyboardKey } from '@shared/utils/constants/keyboard-keys';
import { sendGtmEvent } from '@shared/utils/helpers/send-gtm-event';
import { useClickOutside } from '@shared/utils/hooks/use-click-outside';
import { NotificationsButton } from '../notifications-button/notifications-button';
import styles from './notifications-dropdown.module.scss';
const PARENT_CLASSNAME = 'notifications-dropdown';
const PANEL_ANIMATION_DURATION_MS = 300;
export const NotificationsDropdown = () => {
  const $ = _c(20);
  const [isOpen, setIsOpen] = useState(false);
  const [isExiting, setIsExiting] = useState(false);
  const {
    cmsContent,
    refreshNotifications
  } = useNotifications();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsExiting(true);
      setTimeout(() => {
        setIsOpen(false);
        setIsExiting(false);
      }, PANEL_ANIMATION_DURATION_MS);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const close = t0;
  let t1;
  if ($[1] !== isExiting || $[2] !== isOpen) {
    t1 = () => {
      if (isOpen && !isExiting) {
        close();
      }
    };
    $[1] = isExiting;
    $[2] = isOpen;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const wrapperRef = useClickOutside(t1);
  let t2;
  if ($[4] !== isExiting || $[5] !== isOpen) {
    t2 = event => {
      if (event.key === KeyboardKey.Escape && isOpen && !isExiting) {
        close();
      }
    };
    $[4] = isExiting;
    $[5] = isOpen;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleWrapperKeyUp = t2;
  let t3;
  if ($[7] !== isExiting || $[8] !== isOpen || $[9] !== refreshNotifications) {
    t3 = <NotificationsButton onClick={() => {
      if (isOpen && !isExiting) {
        close();
      } else {
        if (!isOpen) {
          setIsOpen(true);
          refreshNotifications();
        }
      }
      sendGtmEvent({
        action: GTM_ACTION_CLICK,
        event: GTM_EVENT_USER_INTERACTIONS,
        eventName: GTM_EVENT_NAME_HEADER_CLICK,
        label: "Notification"
      });
    }} />;
    $[7] = isExiting;
    $[8] = isOpen;
    $[9] = refreshNotifications;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== cmsContent || $[12] !== isExiting || $[13] !== isOpen) {
    t4 = (isOpen || isExiting) && <div aria-label={cmsContent.notificationsTitle} className={styles[`${PARENT_CLASSNAME}__panel`]} data-entering={!isExiting || undefined} data-exiting={isExiting || undefined} data-placement="bottom" role="dialog"><Card className={styles[`${PARENT_CLASSNAME}__card`]}><div className={styles[`${PARENT_CLASSNAME}__header`]}><h2>{cmsContent.notificationsTitle}</h2><div className={styles[`${PARENT_CLASSNAME}__header-actions`]}><MarkAllAsReadButton /></div></div><div className={styles[`${PARENT_CLASSNAME}__content`]}><NotificationsList /></div></Card></div>;
    $[11] = cmsContent;
    $[12] = isExiting;
    $[13] = isOpen;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== handleWrapperKeyUp || $[16] !== t3 || $[17] !== t4 || $[18] !== wrapperRef) {
    t5 = <div className={styles[PARENT_CLASSNAME]} onKeyUp={handleWrapperKeyUp} ref={wrapperRef} tabIndex={-1}>{t3}{t4}</div>;
    $[15] = handleWrapperKeyUp;
    $[16] = t3;
    $[17] = t4;
    $[18] = wrapperRef;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
};